import { gql, useMutation } from "@apollo/client";

const CREATE_UPDATE_RELATIONSHIP = gql`
  mutation createOrUpdateRelationship(
    $poolType: poolTypeEnumType!
    $memberId: ID!
    $accountId: ID
  ) {
    createOrUpdateRelationship(
      poolType: $poolType
      memberId: $memberId
      accountId: $accountId
    ) {
      poolType
      memberId
    }
  }
`;

const useRelationships = () => {
  const refetchQueries = ["getMemberRelationships"];

  const [createOrUpdateRelationship] = useMutation(CREATE_UPDATE_RELATIONSHIP, {
    refetchQueries
  });

  return {
    createOrUpdateRelationship
  };
};

export default useRelationships;
